import { salesDateRange } from '@klothiq/domain';
import { useAuth } from '@/contexts/AuthContext';
export default function SalesDatePresets({
  onChange,
  onClear,
}: {
  onChange: (range: { from: string; to: string }) => void;
  onClear?: () => void;
}) {
  const { organization } = useAuth();
  return (
    <div className="flex flex-wrap gap-2" aria-label="Quick sale date ranges">
      {(
        [
          ['today', 'Today'],
          ['week', 'This week'],
          ['month', 'This month'],
        ] as const
      ).map(([period, label]) => (
        <button
          key={period}
          type="button"
          onClick={() => onChange(salesDateRange(period, organization?.timezone))}
          className="min-h-11 rounded-lg border border-border bg-card px-3 text-xs font-medium hover:border-primary/50"
        >
          {label}
        </button>
      ))}
      {onClear && (
        <button
          type="button"
          className="min-h-11 rounded-lg px-3 text-xs text-muted-foreground"
          onClick={onClear}
        >
          All dates
        </button>
      )}
    </div>
  );
}
